import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AbstractAlcmeonBackendInterceptor } from './abstract-alcmeon-backend-interceptor';
import { environment } from 'src/environments/environment';

/**
 * Interceptor that sets the 'X-Alcmeon-Client-Version' for calls to alcmeon.com backend
 */
@Injectable()
export class ClientVersionInterceptor extends AbstractAlcmeonBackendInterceptor {
  protected doIntercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const config = {
      headers: request.headers.set('X-Alcmeon-Client-Version', String(environment.ajsClientVersion)),
    };
    return next.handle(request.clone(config));
  }
}
